<template>
  <div class="mb-4 pa-4">
    <health-report-title @save="updateReport" :report="report" @exit="exit"></health-report-title>

    <health-report-exam-enter class="mt-4" title="一、身體基本檢查" :format="basicFormat" ref="basicExam"></health-report-exam-enter>

    <health-report-exam-enter
      class="mt-4"
      title="二、血球指數檢查"
      :format="bloodCellFormat"
      ref="bloodCellExam"
    ></health-report-exam-enter>

    <report-ladyicats-blood-chem-exam
      class="mt-4"
      title="三、血液生化"
      :format="bloodChemFormat"
      ref="bloodChemExam"
      :disabled="['AG']"
    ></report-ladyicats-blood-chem-exam>

    <health-report-exam-enter class="mt-4" title="四、尿液檢查" :format="urineFormat" ref="urineExam"></health-report-exam-enter>

    <health-report-exam-enter
      class="mt-4"
      title="五、快篩試劑檢查"
      :format="reagentFormat"
      ref="reagentExam"
    ></health-report-exam-enter>

    <health-report-image-upload
      ref="imageUpload"
      class="mt-4"
      title="六、影像檢查"
      :imageNumber="4"
      :reportId="reportId"
    ></health-report-image-upload>

    <health-report-conclusion
      class="mt-4"
      title="七、身體檢查報告總結及建議"
      :format="conclusionFormat"
      ref="conclusion"
      :data="conclusionData"
    ></health-report-conclusion>

    <health-report-update-snakebar ref="updateSnakebar"></health-report-update-snakebar>

    <health-report-save-snakebar ref="saveSnakebar"></health-report-save-snakebar>

    <dialog-leave-confirm ref="leaveConfirm"></dialog-leave-confirm>
    <socket-io :focusEvent="focusEvent" @onReceive="onReceive"></socket-io>
  </div>
</template>

<script>
import HealthReportTitle from "./HealthReportTitle";
import HealthReportUpdateSnakebar from "./HealthReportUpdateSnakebar";
import HealthReportSaveSnakebar from "./HealthReportSaveSnakebar";

import HealthReportExamEnter from "./HealthReportExamEnter";
import HealthReportImageUpload from "./HealthReportImageUpload";
import ReportLadyicatsBloodChemExam from "./ReportLadyicatsBloodChemExam";

import HealthReportConclusion from "./HealthReportConclusion";
import DialogLeaveConfirm from "./DialogLeaveConfirm";
import SocketIo from "../../common/SocketIo";

export default {
  props: ["reportId"],
  components: {
    HealthReportTitle,
    HealthReportUpdateSnakebar,
    HealthReportSaveSnakebar,
    HealthReportExamEnter,
    ReportLadyicatsBloodChemExam,
    HealthReportImageUpload,
    HealthReportConclusion,
    DialogLeaveConfirm,
    SocketIo
  },
  data: () => ({
    focusEvent: ["updateReport"],
    autoSaveTimer: "",
    basicFormat: [
      {
        name: "理學檢查",
        examine: [
          {
            name: "體重",
            key: "weight",
            reference: "",
            suffix: "KG"
          },
          {
            name: "口腔檢查",
            key: "oral",
            reference: "",
            suffix: ""
          },
          {
            name: "耳朵檢查",
            key: "ear",
            reference: "",
            suffix: ""
          },
          {
            name: "胸腔聽診",
            key: "chest",
            reference: "",
            suffix: ""
          },
          {
            name: "腹部觸診",
            key: "abdomen",
            reference: "",
            suffix: ""
          },
          {
            name: "毛皮檢查",
            key: "fur",
            reference: "",
            suffix: ""
          },
          {
            name: "糞便檢查",
            key: "poo",
            reference: "",
            suffix: ""
          },
          {
            name: "體溫",
            key: "temp",
            reference: "",
            suffix: ""
          }
        ]
      },
      {
        name: "身體基礎值",
        examine: [
          {
            name: "呼吸",
            key: "breathe",
            reference: "30-40分/下",
            suffix: "下"
          },
          {
            name: "心跳",
            key: "pulse",
            reference: "140-220次/分",
            suffix: "bpm"
          },
          {
            name: "體態評分(BCS)",
            key: "bcs",
            reference: "4/9~5/9",
            suffix: ""
          },
          {
            name: "血壓",
            key: "pressure",
            reference: "120-160mmHg",
            suffix: ""
          }
        ]
      }
    ],
    bloodCellFormat: [
      {
        name: "白血球",
        examine: [
          {
            name: "白血球數目(WBC)",
            key: "WBC",
            reference: "5.5-19.5 K/μL",
            suffix: ""
          },
          {
            name: "淋巴球(LYM)",
            key: "LYM",
            reference: "1.8-7.0 K/μL",
            suffix: ""
          },
          {
            name: "單核球(MONO)",
            key: "MONO",
            reference: "0.2-1.0 K/μL",
            suffix: ""
          },
          {
            name: "嗜中性球(NEUT)",
            key: "NEUT",
            reference: "2.8-13.0 K/μL",
            suffix: ""
          },
          {
            name: "嗜酸性球(EOS)",
            key: "EOS",
            reference: "0.1-1.57 K/μL",
            suffix: ""
          },
          {
            name: "淋巴球(LYM)%",
            key: "LYMp",
            reference: "",
            suffix: ""
          },
          {
            name: "單核球(MON)%",
            key: "MONp",
            reference: "",
            suffix: ""
          },
          {
            name: "嗜中性球(NEU)%",
            key: "NEUp",
            reference: "",
            suffix: ""
          },
          {
            name: "嗜酸性球(EOS)%",
            key: "EOSp",
            reference: "",
            suffix: ""
          }
        ]
      },
      {
        name: "紅血球",
        examine: [
          {
            name: "紅血球數目(RBC)",
            key: "RBC",
            reference: "5.0-11.0 M/μL",
            suffix: ""
          },
          {
            name: "血紅素(HGB)",
            key: "HGB",
            reference: "8-15 g/dL",
            suffix: ""
          },
          {
            name: "血球容積比(HCT)",
            key: "HCT",
            reference: "30.3-52.3 ％",
            suffix: ""
          },
          {
            name: "紅血球平均體積(MCV)",
            key: "MCV",
            reference: "39-50 fL",
            suffix: ""
          },
          {
            name: "平均血色素量(MCH)",
            key: "MCH",
            reference: "12.5-17.5 pg",
            suffix: ""
          },
          {
            name: "平均血球血紅素濃度(MCHC)",
            key: "MCHC",
            reference: "31.0-38.5 g/dL",
            suffix: ""
          },
          {
            name: "紅血球分佈廣度(RDW%)",
            key: "RDWp",
            reference: "20.0-35.0 %",
            suffix: ""
          }
        ]
      },
      {
        name: "血小板",
        examine: [
          {
            name: "血小板總數(PLT)",
            key: "PLT",
            reference: "200-500 K/μL",
            suffix: ""
          },
          {
            name: "平均血小板大小(MPV)",
            key: "MPV",
            reference: "8.0-12.0 fL",
            suffix: ""
          }
        ]
      }
    ],
    bloodChemFormat: [
      {
        name: "腎臟指數",
        examine: [
          {
            name: "血中尿素氮(BUN)",
            key: "BUN",
            reference: "16-36 mg/dL",
            suffix: ""
          },
          {
            name: "肌酸酐(Crea)",
            key: "CREA",
            reference: "0.8-2.4 mg/dL",
            suffix: ""
          }
        ]
      },
      {
        name: "肝臟指數",
        examine: [
          {
            name: "麩丙酮酸轉氨酶(ALT)",
            key: "ALT",
            reference: "12-130 U/L",
            suffix: ""
          },
          {
            name: "鹼性磷酸酶(ALKP)",
            key: "ALKP",
            reference: "14-111 U/L",
            suffix: ""
          },
          {
            name: "天門冬酸轉氨酶(AST)",
            key: "AST",
            reference: "15-44 U/L",
            suffix: ""
          },
          {
            name: "總膽紅素(TBIL)",
            key: "TBIL",
            reference: "0-0.9 mg/dL",
            suffix: ""
          },
          {
            name: "谷胺醯轉移酶(GGT)",
            key: "GGT",
            reference: "0-4 U/L",
            suffix: ""
          },
          {
            name: "飯前膽汁酸檢測",
            key: "bBA",
            reference: "<12μmol/L ",
            suffix: ""
          },
          {
            name: "飯後膽汁酸檢測",
            key: "aBA",
            reference: "<12μmol/L",
            suffix: ""
          }
        ]
      },
      {
        name: "其它",
        examine: [
          {
            name: "血糖(GLU)",
            key: "GLU",
            reference: "74-159 mg/dL",
            suffix: ""
          },
          {
            name: "血氨(NH3)",
            key: "NH3",
            reference: "0-95 μmol/L",
            suffix: ""
          },
          {
            name: "總蛋白(TP)",
            key: "TP",
            reference: "5.7-8.9 g/dL",
            suffix: ""
          },
          {
            name: "白蛋白(ALB)",
            key: "ALB",
            reference: "2.2-4.0 g/dL",
            suffix: ""
          },
          {
            name: "球蛋白(GLOB)",
            key: "GLOB",
            reference: "2.8-5.1 g/dL",
            suffix: ""
          },
          {
            name: "白蛋白/球蛋白(A/G)比",
            key: "AG",
            reference: "",
            suffix: ""
          },
          {
            name: "鈣(CA)",
            key: "Ca",
            reference: "7.8-11.3 mg/dL",
            suffix: ""
          },
          {
            name: "磷(PHOS)",
            key: "PHOS",
            reference: "3.1-7.5 mg/dL",
            suffix: ""
          },
          {
            name: "膽固醇(CHOL)",
            key: "CHOL",
            reference: "65-225 mg/dL",
            suffix: ""
          },
          {
            name: "三酸甘油酯(TRIG)",
            key: "TRIG",
            reference: "<150mg/dL",
            suffix: ""
          },
          {
            name: "甲狀腺(T4)檢測",
            key: "T4",
            reference: "0.8-4.7μg/dL",
            suffix: ""
          },
          {
            name: "胰澱粉酶(Amyl)",
            key: "AMYL",
            reference: "500-1500 U/L",
            suffix: ""
          }
        ]
      },
      {
        name: "離子(電解質)",
        examine: [
          {
            name: "鈉(Na)",
            key: "Na",
            reference: "150-165mmol/L",
            suffix: ""
          },
          {
            name: "鉀(K)",
            key: "K",
            reference: "3.5-5.8mmol/L",
            suffix: ""
          },
          {
            name: "氯(Cl)",
            key: "CL",
            reference: "112-129mmol/L",
            suffix: ""
          }
        ]
      }
    ],
    urineFormat: [
      {
        name: "尿液試紙",
        examine: [
          {
            name: "尿蛋白(protein)",
            key: "PRO",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "葡萄糖(glucose)",
            key: "GLU",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "尿膽素原(urobilinogen)",
            key: "URO",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "尿膽紅素(bilirubin)",
            key: "BIL",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "酮體(ketone)",
            key: "KET",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "酸鹼值 (pH)",
            key: "PH",
            reference: "6.5-7.5 pH",
            suffix: ""
          },
          {
            name: "亞硝酸鹽",
            key: "NIT",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "血尿(occult blood)",
            key: "BLD",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "白血球(leukocytes)",
            key: "LEU",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "尿比重(U.S.G)",
            key: "SG",
            reference: "1.035-1.045",
            suffix: ""
          }
        ]
      },
      {
        name: "尿蛋白/尿肌酸酐比值",
        examine: [
          {
            name: "UPC(氮血症)",
            key: "UPC",
            reference: "0.4以下",
            suffix: ""
          },
          {
            name: "UPC(非氮血症)",
            key: "UPCn",
            reference: "0.5以下",
            suffix: ""
          }
        ]
      }
    ],
    reagentFormat: [
      {
        name: "",
        examine: [
          {
            name: "貓胰臟炎(fPL)檢測",
            key: "fPL",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "貓愛滋/貓白血檢測",
            key: "FIV",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "貓心臟篩檢(proBNP)",
            key: "proBNP",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "貓瘟病毒檢驗",
            key: "FPLV",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "貓冠狀病毒檢驗",
            key: "FCoV",
            reference: "陰性",
            suffix: ""
          },
          {
            name: "貓心絲蟲檢驗",
            key: "FHW",
            reference: "陰性",
            suffix: ""
          }
        ]
      }
    ],
    conclusionFormat: [
      {
        name: "身體基本檢查",
        wordLength: 70,
        rowLength: 3,
        key: "basic",
        type: "textField"
      },
      {
        name: "血液檢查結果",
        wordLength: 70,
        rowLength: 3,
        key: "blood",
        type: "textField"
      },
      {
        name: "尿液檢查結果",
        key: "urine",
        wordLength: 70,
        rowLength: 3,
        type: "textField"
      },
      {
        name: "快篩檢查結果",
        key: "reagent",
        wordLength: 70,
        rowLength: 3,
        type: "textField"
      },
      {
        name: "超音波檢查結果",
        key: "ultraSonic",
        wordLength: 70,
        rowLength: 2,
        type: "textField"
      },
      {
        name: "總結與建議",
        key: "suggestion",
        type: "textArea"
      }
    ],
    conclusionData: {
      suggestion: "",
      basic: [],
      blood: [],
      urine: [],
      reagent: [],
      ultraSonic: []
    },
    report: {}
  }),
  methods: {
    async getReport() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/1/${
          this.reportId
        }`
      );

      console.log("getReport response:" + JSON.stringify(response.data));
      this.$refs.basicExam.setExamData(Object.assign({}, response.data.basic));
      this.$refs.bloodCellExam.setExamData(
        Object.assign({}, response.data.bloodCell)
      );
      this.$refs.bloodChemExam.setExamData(
        Object.assign({}, response.data.bloodChem)
      );
      this.$refs.urineExam.setExamData(Object.assign({}, response.data.urine));
      this.$refs.reagentExam.setExamData(
        Object.assign({}, response.data.reagent)
      );
      this.$refs.imageUpload.setImageArray(response.data.ultrasonic.slice());

      let initSummary = {
        basic: [],
        blood: [],
        urine: [],
        reagent: [],
        ultraSonic: []
      };
      let conclusion = Object.assign(
        {},
        Object.keys(response.data.summary).length > 0
          ? response.data.summary
          : initSummary,
        {
          suggestion: response.data.suggestion
        }
      );

      this.$refs.conclusion.setConData(conclusion);
      this.report = response.data;

      //set previous health report
      if (response.data.previous) {
        response = await this.$ajax.get(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/1/${
            response.data.previous
          }`
        );

        this.$refs.basicExam.setPreviousData(response.data.basic);
        this.$refs.bloodCellExam.setPreviousData(response.data.bloodCell);
        this.$refs.bloodChemExam.setPreviousData(response.data.bloodChem);
        this.$refs.urineExam.setPreviousData(response.data.urine);
        this.$refs.reagentExam.setPreviousData(response.data.reagent);
      }
    },
    async updateReport() {
      let ultrasonic = await this.$refs.imageUpload.getUploadImages();
      let basic = this.$refs.basicExam.getExamData();
      let bloodCell = this.$refs.bloodCellExam.getExamData();
      let bloodChem = this.$refs.bloodChemExam.getExamData();
      let urine = this.$refs.urineExam.getExamData();
      let reagent = this.$refs.reagentExam.getExamData();

      let conclusion = this.$refs.conclusion.getConData();

      const suggestion = conclusion.suggestion;
      let summary = JSON.parse(JSON.stringify(conclusion));
      delete summary["suggestion"];

      let response = await this.$ajax.put(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/${
          this.reportId
        }`,
        {
          basic,
          bloodCell,
          bloodChem,
          urine,
          reagent,
          summary,
          suggestion,
          ultrasonic
        }
      );

      console.log("updateReport response:" + JSON.stringify(response.data));
      this.report = response.data;
      this.$refs.saveSnakebar.show("健檢報告已儲存");
    },
    exit() {
      this.$router.go(-1);
    },
    async hasModified() {
      let basicTest = this.dataCompare(
        this.report.basic,
        this.$refs.basicExam.getExamData()
      );

      let bloodCellTest = this.dataCompare(
        this.report.bloodCell,
        this.$refs.bloodCellExam.getExamData()
      );

      let bloodChemTest = this.dataCompare(
        this.report.bloodChem,
        this.$refs.bloodChemExam.getExamData()
      );

      let urineTest = this.dataCompare(
        this.report.urine,
        this.$refs.urineExam.getExamData()
      );

      let reagentTest = this.dataCompare(
        this.report.reagent,
        this.$refs.reagentExam.getExamData()
      );

      let ultrasonicTest = this.arrayCompare(
        this.report.ultrasonic,
        await this.$refs.imageUpload.getUploadImages()
      );

      let conclusion = this.$refs.conclusion.getConData();
      let summary = this.report.summary;
      let suggestion = this.report.suggestion;

      let conclusionBasicTest = this.arrayCompare(
        summary.basic,
        conclusion.basic
      );
      let conclusionBloodTest = this.arrayCompare(
        summary.blood,
        conclusion.blood
      );
      let conclusionUrineTest = this.arrayCompare(
        summary.urine,
        conclusion.urine
      );
      let conclusionReagentTest = this.arrayCompare(
        summary.reagent,
        conclusion.reagent
      );
      let conclusionUltraSonicTest = this.arrayCompare(
        summary.ultraSonic,
        conclusion.ultraSonic
      );

      let suggestionTest = conclusion.suggestion === suggestion;

      // console.log("basicTest:" + basicTest);
      // console.log("bloodCellTest:" + bloodCellTest);
      // console.log("bloodChemTest:" + bloodChemTest);
      // console.log("urineTest:" + urineTest);
      // console.log("reagentTest:" + reagentTest);
      // console.log("ultrasonicTest:" + ultrasonicTest);

      //{"basic":[],"blood":[],"urine":[],"reagent":[],"ultraSonic":[]}
      // console.log("conclusionBasicTest:" + conclusionBasicTest);
      // console.log("conclusionBloodTest:" + conclusionBloodTest);
      // console.log("conclusionUrineTest:" + conclusionUrineTest);
      // console.log("conclusionReagentTest:" + conclusionReagentTest);
      // console.log("conclusionUltraSonicTest:" + conclusionUltraSonicTest);
      // console.log("suggestionTest:" + suggestionTest);

      return !(
        basicTest &&
        bloodCellTest &&
        bloodChemTest &&
        urineTest &&
        reagentTest &&
        ultrasonicTest &&
        conclusionBasicTest &&
        conclusionBloodTest &&
        conclusionUrineTest &&
        conclusionUltraSonicTest &&
        conclusionReagentTest &&
        suggestionTest
      );
    },
    dataCompare(before, after) {
      let testBefore = Object.keys(before).every(
        key => after.hasOwnProperty(key) && before[key] === after[key]
      );
      let testAfter = Object.keys(after).every(
        key => before.hasOwnProperty(key) && before[key] === after[key]
      );
      return testAfter && testBefore;
    },
    arrayCompare(before = [], after = []) {
      let testBefore = before.every(
        (key, index) => index < after.length && key === after[index]
      );
      let testAfter = after.every(
        (key, index) => index < before.length && key === before[index]
      );
      return testAfter && testBefore;
    },
    async onReceive(event, { reportId }) {
      if (reportId === this.reportId) {
        this.getReport();
        this.$refs.updateSnakebar.show();
      }
    }
  },
  async beforeRouteLeave(to, form, next) {
    const hasModified = await this.hasModified();
    if (hasModified) {
      this.$refs.leaveConfirm.show(next);
    } else {
      next();
    }
  },
  async mounted() {
    this.getReport();
    let thisVm = this;
    this.autoSaveTimer = setInterval(async function() {
      console.log("autoSave");
      await thisVm.updateReport();
    }, 60 * 1000);
  },
  destroyed() {
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer);
    }
  }
};
</script>
